import { event } from "@zillow/universal-analytics";
import { debounce } from "lodash";
const handleFieldChangeEvent = debounce((label, blockType) => {
  sendInteractionEvent(label, blockType);
}, 3e3);
const sendInteractionEvent = (label, blockType) => {
  const newLaneData = {
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "2",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: blockType == "form_field" ? "cms_form" : blockType == "slider" ? "slider" : "cms_toggle",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: {
      block_type_cd: blockType,
      block_id: "dti_calc",
      block_displayed_txt: label
    }
  };
  event(newLaneData);
};
export {
  handleFieldChangeEvent
};
